/** Invite links are `<origin>/?room=CODE`. */
const PARAM = 'room';

let taken: string | null = null;

/**
 * The invite code from `?room=`, read once per page load and removed from the URL. Memoised, so
 * StrictMode's double init sees the same code; `spendInviteCode` ends it once Home unmounts, so
 * leaving a match lands on the menu instead of the invite again.
 */
export function takeInviteCode(): string {
  if (taken !== null) return taken;
  const url = new URL(window.location.href);
  taken = url.searchParams.get(PARAM)?.trim() ?? '';
  if (url.searchParams.has(PARAM)) {
    url.searchParams.delete(PARAM);
    window.history.replaceState(window.history.state, '', url);
  }
  return taken;
}

/** Home left for a match: later visits to Home have no invite. */
export function spendInviteCode() {
  taken = '';
}

/** Tests only: read `?room=` again, as on a fresh page load. */
export function resetInviteCode() {
  taken = null;
}

/**
 * The Join field → a room code. Takes `room=` from a pasted invite link, so players don't have to
 * cut the code out; anything else is the code itself.
 */
export function parseRoomCode(input: string): string {
  const text = input.trim();
  try {
    const code = new URL(text).searchParams.get(PARAM);
    if (code?.trim()) return code.trim();
  } catch {
    // Not a URL: a bare code.
  }
  return text;
}
